import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';

interface Props {
  readonly title: string;
  readonly description?: string | React.ReactElement;
  readonly variant?: 'normal' | 'prominent';
}

export const ApplicationModalTitle: React.FC<Props> = (props: Props): React.ReactElement => {
  const { description, title, variant = 'normal' } = props;

  const titleVariant = React.useMemo((): 'h5' | 'h6' => {
    switch (variant) {
      case 'normal':
        return 'h6';
      case 'prominent':
        return 'h5';
      default:
        throw new Error('invalid modal variant');
    }
  }, [variant]);

  return (
    <Box gap={0.5} mx={4} mb={2} pb={3}>
      <Typography variant={titleVariant}>{title}</Typography>
      {description ? (
        <Box mt={1}>
          {typeof description === 'string' ? (
            <Typography fontSize={16} fontWeight={400} lineHeight="24px" color="custom.LightGray">
              {description}
            </Typography>
          ) : (
            description
          )}
        </Box>
      ) : (
        <></>
      )}
    </Box>
  );
};
